import * as constants from '../constants';

export const wsConnected = () => ({type: constants.WS_CONNECTED});
export const wsConnecting = () => ({type: constants.WS_CONNECTING});
export const wsDisconnected = () => ({type: constants.WS_DISCONNECTED});
